import { render } from "./MemberTasksModal.vue?vue&type=template&id=a0cd86f6"
import script from "./MemberTasksModal.vue?vue&type=script&lang=js"
export * from "./MemberTasksModal.vue?vue&type=script&lang=js"
script.render = render

export default script